import {CustomFilterProps, useGridFilter} from 'ag-grid-react';
import {Checkboxes, Chips, DataStatus, Separator} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import {intersection} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

import {quickFiltersConst} from '../../constants/quickFilters';
import {useChoiceFilter} from '../../hooks/useChoiceFilter';
import {useFilterOnChipsChange} from '../../hooks/useFilterOnChipsChange';
import {useLazyChoiceFilterOptions} from '../../hooks/useLazyChoiceFilterOptions';
import {QuickFilters} from '../../types/Api';

export type CheckboxFilterProps = {
  columnKey: string;
  isDisabled: boolean;
} & CustomFilterProps &
  QuickFilters &
  TestIdProps;

export function CheckboxFilter(props: CheckboxFilterProps) {
  const [values, setValues] = useChoiceFilter(props);
  const {loadOptions, isLoading, options, errorMessage} = useLazyChoiceFilterOptions({
    columnKey: props.columnKey,
  });
  const {onChipsChange} = useFilterOnChipsChange({
    setFilterValue: setValues,
    defaultValue: null,
  });

  const isQuickFilterValue = intersection(isArray(values) ? values : [values], quickFiltersConst);
  const isControlDisabled = props.isDisabled;

  useGridFilter({
    doesFilterPass: () => true,
    afterGuiAttached: () => {
      void loadOptions();
    },
  });

  return (
    <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && (
        <>
          <HStack>
            <Chips
              isDisabled={props.isDisabled}
              value={isQuickFilterValue}
              options={props.quickFilters}
              onChange={onChipsChange}
              isMultiple={false}
              data-testid={suffixTestId('checkbox-filter-quickFilters', props)}
              isDeselectable
            />
          </HStack>
          <Separator />
        </>
      )}
      <DataStatus isLoading={isLoading}>
        <Checkboxes
          options={options}
          value={isArray(values) ? values : null}
          onChange={setValues}
          isDisabled={isControlDisabled}
          errorMessage={errorMessage}
          checkedIcon="navigation/check"
          data-testid={suffixTestId('checkbox-filter', props)}
        />
      </DataStatus>
    </VStack>
  );
}
